import api from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindAuditoriaTasksDto, AuditoriaTaskDto } from './auditoria-tasks.types';

export async function GetAuditoriaTasks(filters: FindAuditoriaTasksDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }
  const response = await api.get<[AuditoriaTaskDto[], number]>(Endpoints.AUDITORIA_TASKS, {
    params: filters,
  });
  return response.data;
}

